import { render, staticRenderFns } from "./detection.vue?vue&type=template&id=1218cffd&scoped=true&"
import script from "./detection.vue?vue&type=script&lang=ts&"
export * from "./detection.vue?vue&type=script&lang=ts&"
import style0 from "./detection.vue?vue&type=style&index=0&id=1218cffd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1218cffd",
  null
  
)

export default component.exports